import { createFileRoute } from '@tanstack/react-router'

import { ClientDetailLayout } from '@/components/layout/clients/client-detail'

export const Route = createFileRoute('/_auth/clients/$clientId')({
  component: ClientDetailPage,
  head: () => ({
    meta: [{ title: 'SUL AI | Client' }],
  }),
})

function ClientDetailPage() {
  const { clientId } = Route.useParams()
  return <ClientDetailLayout clientId={clientId} />
}
